import { extractErrorMessage } from 'app/providers/with-wagmi-auth/utils';
import { selectCurrentPackage } from 'entities/mine-package/model';
import { createAppAsyncThunk, logger, PayloadRejectMessage } from 'shared';

import { estimatePayment } from '../../api';
import { actionTypes } from '../action-types';
import { actions } from '../reducer';

export const estimatePaymentMethod = createAppAsyncThunk<null, undefined, { rejectValue: PayloadRejectMessage }>(
  actionTypes.ESTIMATE_PAYMENT,
  async (_, { getState, dispatch }) => {
    try {
      const state = getState();

      const currentPackage = selectCurrentPackage(state);

      const { data: estimationData } = await estimatePayment({ packageName: currentPackage.name.toUpperCase() });

      dispatch(actions.setEstimatedPayment(estimationData));

      return null;
    } catch (error) {
      logger(actionTypes.ESTIMATE_PAYMENT, error);

      throw new Error(extractErrorMessage(error));
    }
  },
);
